import { useLayoutEffect } from 'react';

function useCursor(cursor: string) {
  useLayoutEffect(() => {
    const style = document.createElement('style');

    if (!document) return;

    const head = document.querySelector('head');

    if (!head) return;

    style.innerHTML = `* { cursor: ${cursor} !important; }`;

    head.appendChild(style);

    return () => {
      style.remove();
    };
  }, [cursor]);
}

export default useCursor;
